import {
  Box,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Modal,
} from '@material-ui/core';
import React from 'react';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { SCHOOL_DETAILS_ROUTE } from '../../../routes/routes';
import GetInTouchForm from './GetInTouchForm';
import SeoData from './SeoData';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export const MANAGEMENT_APP_COLUMN = [
  {
    Header: 'School Id',
    accessor: '_id',
  },
  {
    Header: 'School Name',
    accessor: 'schoolName',
  },
  {
    Header: 'City',
    accessor: 'city',
  },
  {
    Header: 'KYC Status',
    accessor: 'status',
    Cell: (val) => {
      const payload = val.cell.row.original;
      const { kycVerified } = payload;
      return <Box>{kycVerified === true ? 'Done' : 'Pending'}</Box>;
    },
  },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;

      const { _id } = payload;
      const [anchorEl, setAnchorEl] = React.useState(null);
      const [open1, setOpen1] = React.useState(false);
      const [open2, setOpen2] = React.useState(false);
      const handleOpen1 = () => setOpen1(true);
      const handleClose1 = () => setOpen1(false);
      const handleOpen2 = () => setOpen2(true);
      const handleClose2 = () => setOpen2(false);
      const open = Boolean(anchorEl);

      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };

      const handleClose = () => {
        setAnchorEl(null);
      };
      const ITEM_HEIGHT = 48;

      return (
        <Box display="flex">
          <Box width={80} fontSize={14}>
            <IconButton
              aria-label="more"
              aria-controls="long-menu"
              aria-haspopup="true"
              onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="long-menu"
              anchorEl={anchorEl}
              keepMounted
              open={open}
              onClose={handleClose}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: '20ch',
                },
              }}>
              <Link
                style={{ textDecoration: 'none', color: 'black' }}
                href={`${SCHOOL_DETAILS_ROUTE}?schoolId=${_id}`}>
                <MenuItem>View Details</MenuItem>
              </Link>
              <MenuItem onClick={handleOpen1}>Get In Touch</MenuItem>
              <MenuItem onClick={handleOpen2}>Update SEO</MenuItem>
            </Menu>
          </Box>
          <Modal open={open1} onClose={handleClose1}>
            <Box sx={style}>
              <GetInTouchForm id={_id} handleClose={handleClose1} />
            </Box>
          </Modal>
          <Modal open={open2} onClose={handleClose2}>
            <Box sx={{ ...style, width: 800, p: 1 }}>
              <SeoData id={_id} handleClose={handleClose2} />
            </Box>
          </Modal>
        </Box>
      );
    },
  },
];
